module.exports = __webpack_public_path__ + "static/media/press.ccea0af0.cur";